module.exports = __webpack_public_path__ + "img/memorial-2025.f7b80640.jpg";